import { Box, Tooltip, Typography } from '@mui/material';
import { BUILD_COMMIT_SHORT, buildInfoTitle, formattedBuildDate } from '../utils/buildInfo';

export default function BuildVersion() {
  return (
    <Tooltip
      title={<span style={{ whiteSpace: 'pre-line' }}>{buildInfoTitle}</span>}
      placement="top"
    >
      <Box
        title={buildInfoTitle}
        sx={{
          px: 2,
          py: 1.25,
          color: 'text.secondary',
          userSelect: 'text',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          noWrap
          sx={{ fontFamily: 'monospace', lineHeight: 1.4 }}
        >
          build: {BUILD_COMMIT_SHORT}
          <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
            {' '}
            &middot; {formattedBuildDate}
          </Box>
        </Typography>
      </Box>
    </Tooltip>
  );
}
